import go, {Diagram} from 'src/util/gojs/go';

export const commitNodesToDiagram = (diagram: Diagram, {nodes, edges}: {nodes?: Array<any>, edges?: Array<any>}) => {
  if (nodes) {
    diagram.model.addNodeDataCollection(nodes);
  }
  if (edges) {
    (diagram.model as go.GraphLinksModel).addLinkDataCollection(edges);
  }
};
